<template>
  <div class="api-list">
    <Loading
      :active.sync="isLoading"
      :is-full-page="false"
      :color="loaderColor"
      loader="dots"
      :background-color="loaderBackgroundColor"
    />
    <div class="section-header">
      <h3 class="section-title">All the APIs</h3>
      <VasionButton
        class="section-btn last-btn"
        classProp="secondary"
        @vasionButtonClicked="newApiLookupClick"
      >
        New API
      </VasionButton>
    </div>
    <div class="section-content">
      <p>Space for the API list</p>
    </div>
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay'
import { loaderBackgroundColor, loaderColor } from '@/assets/js/styleConfig'

export default {
  name: 'ApiLookupsList',
  components: {
    Loading,
  },
  data() {
    return {
      isLoading: false,
      loaderBackgroundColor: loaderBackgroundColor,
      loaderColor: loaderColor,
    }
  },
  async created() {},
  methods: {
    newApiLookupClick() {
      this.$router.push({
        name: 'NewApiLookup',
        params: { formID: this.$route.params.formID },
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/variables.scss';
@import '@/assets/css/light-theme-system-palette.scss';

.api-list {
  display: flex;
  height: 100%;
  flex: 1 1 auto;
  flex-direction: column;
  overflow: auto;
  padding: 12px;

  .section-header {
    display: flex;
    height: 48px;
    align-items: flex-start;
    gap: 16px;

    .section-title {
      display: flex;
      flex-direction: column;
      justify-content: center;
      flex: 1 0 0;
      margin: auto;

      overflow: hidden;
      color: $vap-temp-title-color;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-family: $font-family-book;
      font-size: 24px;
      font-style: normal;
      font-weight: 400;
      line-height: 32px;
    }

    .section-btn {
      display: flex;
      height: 48px;
      justify-content: flex-end;
      align-items: center;
      gap: 16px;
    }
  }

  .section-content {
    flex: 1 1 auto;
    overflow: auto;
    /* ------------- Remove this section once the table is implemented. BEGIN */
    display: flex;
    justify-content: center;
    align-items: center;

    p {
      font-size: 48px;
      font-weight: bold;
    }

    /* ------------- Remove this section once the table is implemented. END   */
  }
}
</style>
